export default {"src":"/_next/static/media/IconArrowChevronLeft.45372562.svg","height":20,"width":11,"blurWidth":0,"blurHeight":0};